import { InMemoryCache } from '@apollo/client'
import { relayStylePagination } from '@apollo/client/utilities'

const cache = new InMemoryCache({
  dataIdFromObject: (responseObject) => {
    if (responseObject.objectId) {
      return `${responseObject.__typename}:${responseObject.objectId}`
    }
    if (responseObject._id) {
      return `${responseObject.__typename}:${responseObject._id}`
    }
  },
  typePolicies: {
    PublicWebauthnAuthenticator: {
      keyFields: ['id']
    },
    SimilarBrandsMap: {
      keyFields: (responseObject, { typename }) => `${typename}:${responseObject.brand}`
    },
    Query: {
      fields: {
        getSaleItemsBySection: relayStylePagination(['saleId', 'section']),
        syncReservations: {
          merge: false
        },
        orders: relayStylePagination(['where']),
        getOrdersOverviewv2: relayStylePagination(),
        payOuts: relayStylePagination(['where']),
        bags: relayStylePagination(['where', 'first'])
      }
    }
  }
})

export default cache
